import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';
import connect from '../../../store/connect';

import { color } from '../../../styles/helpers/variables';
import { fontFamilyHeading } from '../../../styles/helpers/mixins';
import RenderPrice from '../../../components/RenderPrice';
import { Button } from '../../../styles/Button';

import { SITE_ROOT_URL, CART_ADD_URL } from '../../../constants/endpoints';
import { addCartItem, setViewstate } from '../../../actions/actionCreators';

import { analyticsProductClickEvent } from '../../../util/analyticEvents';

class ProductPageComplimentaryComponent extends Component {
  constructor(props) {
    super(props);
    this.buyButtonActiveTimeout = null;
    this.state = {
      buyButtonActive: false,
    };
    this.buyButtonHandler = this.buyButtonHandler.bind(this);
  }

  buyButtonHandler(id) {
    clearTimeout(this.buyButtonActiveTimeout);
    this.setState(() => ({ buyButtonActive: true }));
    this.props.addCartItem({
      endpointUrl: CART_ADD_URL,
      body: { id, Quantity: 1, Options: [] }
    });
    this.buyButtonActiveTimeout = setTimeout(() => this.setState(() => ({ buyButtonActive: false })), 1800);
    this.props.setViewstate('productAddedToCart', true);
  }

  render() {
    const { product } = this.props;

    if (!product.get('url')) {
      return null;
    }

    if (!product.get('variants', List).size) {
      return (
        <ComplimentaryProduct>
          <ComplimentaryProductImage>
            <a
              href={product.get('url')}
              onClick={() => {
                analyticsProductClickEvent('productClick', 'Complimentary Products', product);
              }}
            >

              <img
                src={SITE_ROOT_URL + product.getIn(['images', 0, 'url'])}
                alt={product.getIn(['images', 0, 'alt'])}
              />
            </a>
          </ComplimentaryProductImage>
          <ComplimentaryProductContent>
            <ComplimentaryProductBrand>{product.getIn(['brand', 'name'])}</ComplimentaryProductBrand>
            <ComplimentaryProductName>
              <a
                href={product.get('url')}
                onClick={() => {
                  analyticsProductClickEvent('productClick', 'Complimentary Products', product);
                }}
              >
                {product.get('name')}
              </a>
            </ComplimentaryProductName>
            <RenderPrice
              small
              fontWeight="600"
              price={product.get('price')}
              originalPrice={product.get('originalPrice')}
            />
            <ButtonContainer>
              <Button
                success
                smallBuy
                disabled={this.state.buyButtonActive}
                active={this.state.buyButtonActive}
                onClick={() => {
                  this.buyButtonHandler(product.get('defaultVariantId'));
                }}
              >
                Lägg i varukorg
              </Button>
            </ButtonContainer>
          </ComplimentaryProductContent>
        </ComplimentaryProduct>
      );
    }

    const cheapestVariant = product
      .get('variants')
      .sortBy(variant => variant.get('price'))
      .take(1)
      .get(0);

    const usePriceFrom =
      product.get('variants').filter(variant => variant.get('price') === cheapestVariant.get('price')).size !==
      product.get('variants').size;

    return (
      <ComplimentaryProduct>
        <ComplimentaryProductImage>
          <a
            href={product.get('url')}
            onClick={() => {
              analyticsProductClickEvent('productClick', 'Complimentary Products', product);
            }}
          >
            <img
              src={SITE_ROOT_URL + product.getIn(['mainImage', 'url'])}
              alt={product.getIn(['mainImage', 'alt'])}
            />

          </a>
        </ComplimentaryProductImage>
        <ComplimentaryProductContent>
          <ComplimentaryProductBrand>{product.getIn(['brand', 'name'])}</ComplimentaryProductBrand>
          <ComplimentaryProductName>
            <a
              href={product.get('url')}
              onClick={() => {
                analyticsProductClickEvent('productClick', 'Complimentary Products', product);
              }}
            >
              {product.get('name')}
            </a>
          </ComplimentaryProductName>
          <RenderPrice
            small
            fontWeight="600"
            priceFrom={usePriceFrom}
            price={cheapestVariant.get('price')}
            originalPrice={cheapestVariant.get('originalPrice')}
          />
          <ButtonContainer>
            <Button
              success
              smallBuy
              disabled={this.state.buyButtonActive}
              active={this.state.buyButtonActive}
              onClick={() => {
                this.buyButtonHandler(product.get('defaultVariantId'));
              }}
            >
              Lägg i varukorg
            </Button>
          </ButtonContainer>
        </ComplimentaryProductContent>
      </ComplimentaryProduct>
    );
  }
};

ProductPageComplimentaryComponent.defaultProps = {
  product: Map(),
};

ProductPageComplimentaryComponent.propTypes = {
  product: PropTypes.instanceOf(Map),
  setViewstate: PropTypes.func.isRequired,
  addCartItem: PropTypes.func.isRequired,
};

const ProductPageComplimentary = connect(ProductPageComplimentaryComponent, { addCartItem, setViewstate }, () => ({}));

const ComplimentaryProduct = styled.div`
  display: flex;
`;
const ComplimentaryProductImage = styled.div`
  flex: 0 0 120px;
  align-self: flex-start;
  position: relative;
  max-width: 120px;
  background-color: #ffffff;
  &:after {
    content: '';
    display: block;
    padding: 0 0 100%;
  }
  >a {
    >img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      padding: 10px;
      object-fit: contain;
    }
  }
`;
const ComplimentaryProductContent = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 0 0 0 15px;
`;
const ComplimentaryProductBrand = styled.div`
  margin: 0 0 2.5px;
  color: #a7a7a7;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.125em;
  text-transform: uppercase;
`;
const ComplimentaryProductName = styled.h3`
  margin: 0 0 2.5px;
  color: ${color.black};
  ${fontFamilyHeading};
  font-size: 14px;
  font-weight: 400;
  line-height: 1.25;
  @media screen and (min-width: 960px) {
    font-size: 17px;
  }
  >a {
    color: inherit;
    text-decoration: none;
  }
  +div {
    margin: 0 !important;
    >p {
      font-size: 14px;
      >span {
        font-size: 10px;
      }
    }
  }
`;
const ButtonContainer = styled.div`
  margin: auto 0 0;
  padding: 7.5px 0 0;
  >button {
    margin: 0;
  }
`;

const ProductPageComplimentaryProducts = ({ complementaryProducts }) => {
  if (!complementaryProducts.size) {
    return null;
  }
  return (
    <ComplementaryProductsList>
      {complementaryProducts.map(product => (
        <ComplementaryProductsListItem key={`complementary-product-list-item-${product.get('id')}`}>
          <ProductPageComplimentary product={product} />
        </ComplementaryProductsListItem>
      )).toArray()}
    </ComplementaryProductsList>
  );
};

const ComplementaryProductsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;
const ComplementaryProductsListItem = styled.li`
  margin: 0 0 15px;
  &:last-child {
    margin: 0;
  }
`;

ProductPageComplimentaryProducts.defaultProps = {
  complementaryProducts: Map(),
};

ProductPageComplimentaryProducts.propTypes = {
  complementaryProducts: PropTypes.oneOfType([PropTypes.instanceOf(Map), PropTypes.instanceOf(List)]),
};

export default ProductPageComplimentaryProducts;



// WEBPACK FOOTER //
// ./src/components/productPage/ProductPageComplimentaryProducts/ProductPageComplimentaryProducts.js